import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { collection, orderBy, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch, useSelector } from "react-redux";
import { conversationsActions } from "store/conversations";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";

export default function ConversationsLoader() {
  const dispatch = useDispatch();

  const auth = useAuth();
  const botState = useSelector((state) => state.bot);

  // const [conversationsSnap, loading, error] = useCollection(
  //   botState.current
  //     ? query(
  //         collection(
  //           db,
  //           COLLECTIONS.bots,
  //           botState.current,
  //           COLLECTIONS.conversations
  //         ),
  //         where("uid", "==", auth.currentUser.uid),
  //         orderBy("createdAt", "desc")
  //       )
  //     : null
  // );


  const [conversationsSnap, loading, error] = useCollection(
    botState.current && auth.currentUser.uid
      ? query(
          collection(db, COLLECTIONS.conversations),
          where("botId", "==", botState.current),
          where("uid", "==", auth.currentUser.uid),
          orderBy("createdAt", "desc")
        )
      : null
  );

  useEffect(() => {
    if (botState.current && auth.currentUser) {
      dispatch(
        conversationsActions.setState({
          conversations: snapshotToArray(conversationsSnap),
          loading,
          error,
        })
      );
    }
  }, [botState.current, auth.currentUser, conversationsSnap, loading, error]);

  return null;
}
